const styleSheet = () => ({
  container: {
    height: '100vh',
    maxWidth: '855px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    '@media (max-width: 900px)': {
      width: '85%',
      justifyContent: 'unset',
      gap: '28px',
      marginTop: '50px',
    },
  },
  appilyContainer: {
    borderTop: '1px solid #B7C1E1',
    maxWidth: '855px',
    margin: '0 30px',
    '@media (max-width: 900px)': {
      maxWidth: '100%',
      margin: 0,
    },
  },
  flexContainer: {
    display: 'flex',
    textAlign: 'left',
    marginTop: '45px',
    justifyContent: 'space-between',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      marginTop: '26px',
    },
  },
  textContainer: {
    fontFamily: 'CircularStd, sans-serif',
    maxWidth: '493px',
    color: '#031D32',
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: '16px',
    },
  },
  stars: {
    transform: 'scale(0.85)',
  },
  header: {
    color: '#031D32',
    display: 'inline-block',
    fontFamily: 'MuseoSansBold, CircularStd',
    '@media (max-width: 900px)': {
      padding: 0,
      margin: 0,
    },
  },
  subHeader: {
    color: '#031D32',
    fontFamily: 'MuseoSansStd, CircularStd',
    marginLeft: '35px',
    marginTop: '-12px',
    letterSpacing: '0.3px',
    '@media (max-width: 900px)': {
      margin: 0,
    },
  },
  appilyButton: {
    color: '#031D32',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    gap: '2px',
    border: 'none',
    backgroundColor: '#F8971D',
    borderRadius: '10px',
    height: '48px',
    padding: '0 24px',
    fontFamily: 'MuseoSansBold, CircularStd',
    fontSize: '14px',
    letterSpacing: '0.8px',
    '&:hover': {
      backgroundColor: '#ea8f1d',
    },
    '@media (max-width: 900px)': {
      width: '100%',
      marginTop: '26px',
      fontSize: '16px',
      justifyContent: 'center',
    },
  },
  arrow: {
    transform: 'scale(0.6)',
    marginTop: '1px',
  },
  overlay: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 5000,
    background: '#534e4e3b',
  },
  overlayContent: {
    position: 'absolute',
    bottom: 0,
    height: '220px',
    width: '100%',
    padding: '50px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#1f1f1ff0;',
    color: '#fff',
    fontFamily: 'CircularStd, sans-serif',
    letterSpacing: '0.5px',
    '@media (max-width: 900px)': {
      height: '300px',
    },
  },
  overlayText: {
    width: '30%',
    textAlign: 'center',
    lineHeight: '26px',
    fontSize: '16px',
    '@media (max-width: 900px)': {
      width: '70%',
      fontSize: '18px',
    },
  },
  overlayContinue: {
    color: '#fff',
    '@media (max-width: 900px)': {
      fontSize: '18px',
    },
  },
  closeButton: {
    position: 'absolute',
    right: '50px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    filter: 'invert(100%) brightness(500%)',
    transform: 'scale(1.3)',
    '@media (max-width: 900px)': {
      right: '20px',
    },
  },
  appilyLogo: {
    width: '100px',
  },
});

export default styleSheet;
